import React from 'react'
import "./bienvenida.css";
export default function TyC() {
    return(
        <div className='bienvenida-background'>
            <div className='contenedor-bienvenida'>
                <h1 className='titulo-bienvenida'>
                    ¡Gracias por visitar Chamuscón!
                </h1>
                <p className='mensaje-bienvenida'>
                    Presiona el botón de abajo para encontrar canchas de futbol
                    cerca de tu ubicación.
                </p>
            </div>
        </div>
    )
}